import { makeAutoObservable } from 'mobx'
import { apiService } from '@/services/Api'
import { MktuClass } from '@/services/Api/generated'

import { MktuClassStore } from '@/store/Mktu/MktuClass'
import { Loader } from '@/helpers/Loader'

import { MKTU_CLASS_CATEGORY } from '@/models/Mktu'

export class MktuClassesList {
  classes: MktuClassStore[] = []
  loader = new Loader(() => this._getData(), {
    withDebounce: true,
    debounceDelay: 800,
  })

  get mapClassesByType() {
    return {
      [MKTU_CLASS_CATEGORY.PRODUCT]: this.classes.filter(
        (c) => c.type === MKTU_CLASS_CATEGORY.PRODUCT
      ),
      [MKTU_CLASS_CATEGORY.SERVICE]: this.classes.filter(
        (c) => c.type === MKTU_CLASS_CATEGORY.SERVICE
      ),
    }
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  getByClassNumber(number: MktuClass['classNumber']): MktuClassStore {
    const foundClass = this.classes.find((c) => c.number === number)
    if (foundClass == null) {
      throw new Error(`Class '${number}' not found`)
    }

    return foundClass
  }

  processData(data: MktuClass[]) {
    const classes = data.map((item) => {
      return new MktuClassStore(item)
    })
    this.setClasses(classes)
  }

  setClasses(classes: MktuClassStore[]) {
    this.classes = classes
  }

  private async _getData() {
    if (this.classes.length === 0) {
      const response = await apiService.mktu.getClasses()
      if (response.status) {
        this.processData(
          response.data?.map((d) => ({
            ...d,
            classNumber: Number(d.classNumber),
          })) ?? []
        )
      }
    }
  }
}

export const mktuClassesList = new MktuClassesList()
